import { Timeframe } from '../../../../../components/stats/filters/StatsDateRange'

export const BUDGET_HISTORY_TIMEFRAME = Timeframe.LAST_30_DAYS

/** `days` argument of the `adGroupBudgetHistory` query, matching `BUDGET_HISTORY_TIMEFRAME`. */
export const BUDGET_HISTORY_DAYS = 30
